export const tabsMockData:{
    role: string,
    module: string,
    tabs: {
        tab: string,
        component: string,
        sort: number
    }[]
}[] = [
   
    {
        role: "TLBLG",
        module: "Master Scoping",
        tabs: [
            // {
            //     tab: "Agreement",
            //     component: "AgreementDetails",
            //     sort: 0
            // },
            {
                tab: "Scoping",
                component: "MasterScopingSetup",
                sort: 1
            },
            {
                tab: "Commercials",
                component: "CommercialMapping",
                sort: 2
            },
            {
                tab: "State Billing Master",
                component: "StateBillingMaster",
                sort: 3
            },
            // {
            //     tab: "Activity Calendar",
            //     component: "ActivityCalender",
            //     sort: 4
            // },
            {
                tab: "PO",
                component: "PO",
                sort: 4
            }
        ]
    },
        {
            role: "TLFINP",
            module: "Invoice",
            tabs: [
                {
                    tab: "Invoicing",
                    component: "Invoice",
                    sort: 0
                },
                {
                    tab: "Reports",
                    component: "Reports",
                    sort: 1
                }
            ]
        },
        {
            role: "TLFINR",
            module: "Invoice",
            tabs: [
                {
                    tab: "Invoicing",
                    component: "Invoice",
                    sort: 0
                },
                {
                    tab: "Reports",
                    component: "Reports",
                    sort: 1
                }
            ]
        }
]

